import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BfAuthGuard } from '@brafton/skynet-angular-security-service';

import { SearchResults } from './views';
import { SearchView } from './views/search/search.view';

export const routes: Routes = [
  {
    path: 'advanced-search',
    component: SearchView,
    canActivate: [BfAuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'search-results',
        pathMatch: 'full',
      },
      {
        path: 'search-results',
        component: SearchResults,
        pathMatch: 'full',
        data: { title: 'Search results' },
      },
      {
        path: '**',
        redirectTo: 'search-results',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'advanced-search',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SearchRoutingModule {}
